import Vue from 'vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { AsYouType } from 'libphonenumber-js';
import Datepicker from 'vuejs-datepicker';

Vue.component('hosted-form-validated-field', {
    components: {
        'vuephonenumberinput': VuePhoneNumberInput,
        Datepicker
    },
    data() {
        return {
            fileList: [],
            phoneField: {
                phone: null,
                hasError: false,
                defaultCountryCode: null,
                preferredCountries: null
            },
            phoneInputChangedDebounce: null,
            fileSizeError: null
        }
    },
    props: {
        fieldKey: String,
        fieldIndex: String,
        openIdFieldKey: String,
        errors: {
            type: Object,
            default: () => ({})
        },
        type: String,
        required: String,
        item: Object,
        slideDefault: {
            type: Number,
            default: null
        },
        maxFilesCount: Number,
        singleFileSize: Number,
        multipleFilesSize: Number,
        phoneCountryLabel: String,
        phoneNumberLabel: String,
    },
    computed: {
        hasError() {
            if (this.type === 'file' || this.type === 'multiple_file' && this.errors[`${this.fieldKey}.${this.fieldIndex}`]) {
                const direct = this.errors[`${this.fieldKey}.${this.fieldIndex}`];
                const firstIdx = this.errors[`${this.fieldKey}.0`];
                return !!(this.errors?.files_max_size || direct || firstIdx)
            }

            return this.errors && this.errors.hasOwnProperty(this.fieldKey);
        },
        errorText() {
            if (!Object.keys(this.errors).length) {
                return null;
            }

            if (
                (this.type === 'file' || this.type === 'multiple_file')
                && (this.errors[`${this.fieldKey}.${this.fieldIndex}`] || this.errors[`${this.fieldKey}.0`])
            ) {
                const key = this.errors[`${this.fieldKey}.${this.fieldIndex}`]
                    ? `${this.fieldKey}.${this.fieldIndex}`
                    : `${this.fieldKey}.0`;
                const msgs = this.errors[key];

                return Array.isArray(msgs) ? msgs.join(' ') : msgs;
            }

            const fieldErrs = this.errors[this.fieldKey];
            if (Array.isArray(fieldErrs) && fieldErrs.length) {
                return fieldErrs.join(' ');
            }

            return null;
        },
        openIdValue() {
            return this.openIdFieldKey && this.$parent?.openIdUser?.[this.openIdFieldKey]
                ? this.$parent.openIdUser[this.openIdFieldKey]
                : null;
        }
    },
    created() {
        if (this.openIdValue) {
            this.$parent.form[this.fieldKey] = this.openIdValue;
        }

        this.initPhoneInput();

        if (this.type === 'slider' && !this.$parent.form[this.fieldKey] && this.slideDefault !== null) {
            this.$parent.form[this.fieldKey] = this.slideDefault
        }
    },
    mounted() {
        if (this.type === 'tel') {
            this.$nextTick(() => this.labelPhoneInputs());
            // The phone widget renders its inputs asynchronously (fetch-country); retry until they exist.
            let attempts = 0;
            const timer = setInterval(() => {
                attempts += 1;
                if (this.labelPhoneInputs() || attempts >= 20) {
                    clearInterval(timer);
                }
            }, 150);
        }
    },
    methods: {
        fileAdded({target}) {
            try {
                this.fileList = [];
                for (let i = 0; i < target.files.length; i++) {
                    let file = target.files[i];
                    this.fileList.push(file.name)
                }
                if (target.files.length) {
                    this.$parent.pushFile(target.files, this.fieldKey);
                } else {
                    this.$parent.pushFile('', this.fieldKey);
                }
            } catch (e) {
                console.error(e);
            }
        },
        attachCheckboxGroup($event) {
            this.$parent.pushCheckboxGroup($event, this.fieldKey);
        },
        attachNewsletterCheckbox($event) {
            this.$parent.pushNewsletterCheckbox($event, this.fieldKey);
        },
        triggerClick(refName) {
            this.$refs[refName].click();
        },
        isCheckedValue(value) {
            return this.$parent.form[this.fieldKey] && this.$parent.form[this.fieldKey].length && !!this.$parent.form[this.fieldKey].find(element => element === value);
        },
        initPhoneInput() {
            //apply special options for "tel" field
            if (this.type === 'tel') {
                this.phoneInputChangedDebounce = _.debounce((value) => {
                    if (value.formatNational) {
                        this.phoneInputChanged(value);
                    }
                }, 1000);

                if (this.$parent.form.hasOwnProperty(this.fieldKey) && this.$parent.form[this.fieldKey].hasOwnProperty('phoneNumber')) {
                    this.phoneField.phone = this.$parent.form[this.fieldKey].phoneNumber;
                }

                if (this.$parent.form.hasOwnProperty(this.fieldKey)) {
                    this.$parent.form[this.fieldKey]['required'] = !!this.required;
                } else {
                    this.$parent.form[this.fieldKey] = {
                        'required': !!this.required
                    };
                }
            }
        },
        phoneInputChanged(value) {
            this.$parent.form[this.fieldKey] = value;
            this.$parent.form[this.fieldKey]['required'] = !!this.required;
            this.phoneField.hasError = !value.isValid;
            this.$parent.validateFormStep(this.$parent.currentStep, this.fieldKey)
        },
        sliderLimit(max = 100) {
            if (this.$parent.form[this.fieldKey] > max) {
                return this.$parent.form[this.fieldKey] = max
            }
        },

        getItemsRow(min, max, reverse = false) {
            const list = [];
            for (let i = min; i <= (max); i++) {
                if (i <= max) {
                    list.push(i);
                }
            }

            if (reverse) {
                return list.slice().reverse();
            }

            return list;
        },
        labelPhoneInputs() {
            const root = this.$el;
            if (!root || typeof root.querySelector !== 'function') {
                return false;
            }

            const country = root.querySelector('.country-selector__input');
            const number = root.querySelector('.input-tel__input');
            if (!country && !number) {
                return false;
            }

            if (country && !country.getAttribute('aria-label') && this.phoneCountryLabel) {
                country.setAttribute('aria-label', this.phoneCountryLabel);
            }
            if (number && !number.getAttribute('aria-label') && this.phoneNumberLabel) {
                number.setAttribute('aria-label', this.phoneNumberLabel);
            }

            // The widget renders an unassociated <label> for the flag; hide it from AT (the input already has a name).
            root.querySelectorAll('.country-selector__label').forEach((el) => {
                if (!el.hasAttribute('for')) {
                    el.setAttribute('aria-hidden', 'true');
                }
            });
            return true;
        },
        onPhoneInput(val) {
            if (val) {
                this.phoneField.phone = val;

                const parsed = new AsYouType();
                parsed.input(val);

                const country = parsed.getCountry();
                if (country) {
                    this.phoneField.defaultCountryCode = country;
                    this.phoneField.phone = null;
                }
            }
        },
        humanFileSize(size) {
            let i = Math.floor( Math.log(size) / Math.log(1024) );
            return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ['B', 'KB', 'MB', 'GB', 'TB'][i];
        },
        getFileSizeText() {
            //if form has custom info msgs
            if (this.hasFilledCustomInfoMsges()) {
                return Object.values(this.getEnrichedCustomInfoMsges())
                    .filter(value => value !== null && value !== undefined && String(value).trim() !== '')
                    .join('</br>');
            }

            //default info msg fallback
            const size = this.type === 'multiple_file'
                ? this.humanFileSize(this.multipleFilesSize)
                : this.humanFileSize(this.singleFileSize);
            const formats = Array.isArray(this.item?.acceptedFormats) && this.item.acceptedFormats.length
                ? this.item.acceptedFormats
                : [];
            const acceptedFormatsText = Array.isArray(formats) && formats.length
                ? ` ${formats.join(', ')}`
                : '';

            return `${this.$t('form_builder.files.info', {'size': `${size}`})}${acceptedFormatsText}`;
        },

        hasFilledCustomInfoMsges() {
            return Object.values(this.item?.customInfoMsges || {}).some(value => {
                return value !== null && value !== undefined && String(value).trim() !== '';
            });
        },
        getEnrichedCustomInfoMsges() {
            return Object.fromEntries(
                Object.entries(this.item?.customInfoMsges || {}).map(([key, value]) => {
                    if (typeof value !== 'string') {
                        return [key, value];
                    }

                    let enrichedValue = value;
                    const isFileInfoMessage = key === 'single_file_custom_info_msg' || key === 'multi_file_custom_info_msg';

                    //enrich file_size
                    if (isFileInfoMessage) {
                        //enrich file_size
                        enrichedValue = enrichedValue.replaceAll('{file_size}', this.humanFileSize(this.singleFileSize));

                        //enrich file_format
                        const acceptedFormats = Array.isArray(this.item?.acceptedFormats) && this.item.acceptedFormats.length
                            ? this.item.acceptedFormats.join(', ')
                            : '';
                        enrichedValue = enrichedValue.replaceAll('{file_formats}', acceptedFormats);

                        //enrich max_files_count
                        enrichedValue = enrichedValue.replaceAll('{max_files_count}', this.maxFilesCount);
                    }

                    return [key, enrichedValue];
                })
            );
        }
    }
});
